/*
    Description: js main menu burger click and overlay class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

import Alerts from "./alerts";

//menu overlay class
class Menu extends Alerts{

    // constructor
    constructor(){

        // get constructor/params from alerts
        super();

        // init selectors and classes
        this.bodyHomeClass = "home";
        this.menuClassName = "nav__ul__item__menu";
        this.menuCloseClass = "nav__ul__item__menu__close";
        this.menuLogo = "nav__ul__item__link__logo";
        this.menuIconWrapper = "nav__ul__item__wrapper";
        this.subMenuClass = "sub-menu";
        this.subMenuCollapseClass = "submenu-icon-collapse";
        this.subMenuExpandClass = "submenu-icon-expand";
        this.searchIcon = "search__molab";
        this.iconSelector = "burger";
        this.iconExpandClass = "expand";
        this.iconExpandSubMenu = "menu-item-has-children"; 
        this.bannerClass = "--banner";
        this.pageBannerClass = "banner";
        this.menuSlideInClass = "--menuSlide";
        this.opacityClass = "--transparent";
        this.invisibleClass = "--invisible";
        this.current = "--current";
        this.brightnessClass = "--bright";
        this.menuClass = "--menu";
        this.noScroll = "--noscroll";
        
        // get body tag
        this.body = document.getElementsByTagName("body")[0];

        //get header tag
        this.header = document.getElementsByTagName("header")[0];

        // get header menu element
        this.menu = (this.header) ? this.header.querySelector(`.${this.menuClassName}`) : null;

        // get header logo
        this.logo = (this.header) ? this.header.querySelector(`.${this.menuLogo}`) : null;

        // get the icon wrapper
        this.iconWrapper = (this.header) ? this.header.querySelector(`.${this.menuIconWrapper}`) : null;

        // get menu icon
        this.icon = (this.header) ? this.header.querySelector(`.${this.iconSelector}`) : null;
        
        // get sub menu items
        this.subMenus = (this.menu) ? this.menu.querySelectorAll(`.${this.iconExpandSubMenu}`) : null;

        // get menu close bttn
        this.close = (this.menu) ? this.menu.querySelector(`.${this.menuCloseClass}`) : null;

        // how many pixels to scroll before event fires off
        this.scrollLimit = 50;

        // icon change delay offset
        this.offset = 0.5;

        // link menu collapse opacity speed
        this.opacitySpeed = 0.3;

        //delay time for icon revert 
        this.speed = 0.5;

        // setup events
        this.events();

    }

    // ----------------------- //
    // METHODS --------------- //
    // ----------------------- //
    //EVENTS methods
    events(){

        // init focus on logo on page load
        if(this.logo) this.logo.parentNode.focus({preventScroll:true});  

        // check if we have burger menu icon
        if(this.icon){

            // add click event to burger menu
            this.icon.addEventListener("click", this.expandWholeMenu.bind(this));
            
            // add event keyup
            this.icon.addEventListener("keyup", (e) => {

                // stop propagation
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();

                // check if enter was pressed
                if(e.key.toLowerCase() === "enter"){

                    // expand menu
                    this.expandWholeMenu(e);            
                    
                }
                
            });
            
        }

        // close the menu overlay
        if(this.close) this.close.addEventListener("click", this.collapseWholeMenu.bind(this));

        //add sub menu icons
        this.addSubMenuIcon();

        // add homepage menu scroll method
        this.menuHome();

        // dynamically add anchors to href with (#)
        this.pound();

    }

    // homepage menu scroll effect
    menuHome(){

        // get the body tag and then check if we have the home class -- then check if banner exists
        const banner = (this.body) ? document.querySelector(`.${this.bannerClass}`) : null;

        // check if banner class exists
        if(banner){
            
            // make sure menu is in proper state on load
            this.homeMenuScroll(null);

            // add scroll event listener
            document.addEventListener("scroll", this.homeMenuScroll.bind(this));

        }

    }

    // homepage menu scroll function 
    homeMenuScroll(e){

        // add alertscroll
        this.alertScroll(e);

        //init
        const headerClassList = (this.header) ? this.header.classList : null,
            logoClassList = (this.logo) ? this.logo.classList : null,
            iconClassList = (this.iconWrapper) ? this.iconWrapper.classList : null;

        //if we have scrolled the page
        if(window.pageYOffset > 0){

            // remove classes
            if(headerClassList) headerClassList.remove(this.menuClass);
            if(logoClassList) logoClassList.remove(this.brightnessClass);
            if(iconClassList) iconClassList.remove(this.brightnessClass);
            
        // we have scrolled within scrollLimit
        }else{
            
            // add classes
            if(headerClassList) headerClassList.add(this.menuClass);
            if(logoClassList) logoClassList.add(this.brightnessClass);
            if(iconClassList) iconClassList.add(this.brightnessClass);

        }

    }

    //add expand icon to all links with sub-menu uls
    addSubMenuIcon(){

        // make sure subMenus exists or display error and die
        if((this.subMenus == null)||(this.subMenus.length <= 0)){

            // display error msg 
            // console.log(`%c Error: Could not find the element using the selector: '.${this.iconExpandSubMenu}'!!!`, 'background:#f00; color:#fff');

            // return
            return;

        }

        // loop thru all sub menu items
        for(const link of this.subMenus){
            
            // create element
            const expandLink = document.createElement("button"),
                collapseLink = document.createElement("button");

            // add class
            expandLink.classList.add(this.subMenuExpandClass);
            collapseLink.classList.add(this.subMenuCollapseClass);
            
            // add collapse accessibility label
            collapseLink.setAttribute("aria-label", "Click here to go back to previous menu");

            // get sub menu of current link and first child of submenu item
            const subMenuItem = link.querySelector(`.${this.subMenuClass}`);

            // make sure we have subMenuItem
            if(subMenuItem){

                // init subMenuFirstItem
                const subMenuFirstItem = subMenuItem.children;

                // hide sub menu because when resized the transitions shows the sub menu
                subMenuItem.classList.add(this.opacityClass);

                // add our new element to the link
                link.insertBefore(expandLink, subMenuItem);

                // go back link - place before copy
                subMenuFirstItem[0].insertBefore(collapseLink, subMenuItem.children[0].children[0]);

                // add event listeners to each link
                expandLink.addEventListener("click", this.expandLink.bind(this));
                collapseLink.addEventListener("click", this.collapseLink.bind(this));

                // get expandLinks parent link copy
                const expandLabel = (expandLink.parentNode) ? `the ${expandLink.parentNode.querySelector("a").textContent} sub-menu` : "next menu";
                
                // add expandLinks parent copy to aria label for our expandLink
                expandLink.setAttribute("aria-label", `Click here to go ${expandLabel}`);

            //ERROR
            }else{

                //show error msg
                // console.log(`%c Error: Could not find the element using the selector: '.${this.subMenuClass}'!!!`, 'background:#f00; color:#fff');

            }

        }

    }

    //MAIN MENU: expand main menu and change burger menu icon
    expandWholeMenu(e){

        // prevent default behavior
        e.preventDefault();

        // grab burger menu child element
        const burger = e.currentTarget.children[0];

        // change icon or revert to default
        if(!burger.classList.contains(this.iconExpandClass)) burger.classList.add(this.iconExpandClass);  
        
        // make sure we have a menu
        if(this.menu){

            // show menu overlay 
            this.menu.classList.add(this.menuSlideInClass);
            this.menu.classList.remove(this.opacityClass, this.invisibleClass);

            // update aria-hidden attribute
            this.menu.setAttribute("aria-hidden", false); 
            
            // disable scroll on body
            this.body.classList.add("--noscroll");

            // set menu root as --current
            this.menu.querySelector('ul').classList.add(this.current);

            // add accessibility
            this.accessibility();
        
        // ERROR
        }else{

            // show error msg
            // console.log(`%c Error: Could not find the element using the selector: '.${this.menuClassName}'!!!`, 'background:#f00; color:#fff');
            
        }

    }

    //MAIN MENU: collapse main menu and revert burger icon
    collapseWholeMenu(e){

        // prevent default behavior
        e.preventDefault();

        // remove no scroll on main menu
        this.menu.classList.remove(this.noScroll);

        // make sure subMenus exists or display error and die
        if(!this.menu){

            // display error msg 
            // console.log(`%c Error: Could not find the element using the selector: '.${this.menuClassName}'!!!`, 'background:#f00; color:#fff');
            
            // return
            return;
            
        }

        // remove any --current class within our menu
        this.currentMenu();

        //init main menu collapse and icon offset speed default values 
        let menuCollapseSpeed = 1,
            iconChangeSpeedOffset = 0;  
        
        //get --menuSlide count
        const slideMenuCount = this.menu.querySelectorAll(`.${this.menuSlideInClass}`);
        
        // check if sub menu is visible 
        if(slideMenuCount && (slideMenuCount.length > 0)){

            // delay menu collapse speed
            menuCollapseSpeed = (this.speed * 1000);

            // delay icon change speed
            iconChangeSpeedOffset = this.offset;

            // make sure we have subMenu
            if(this.subMenus && (this.subMenus.length > 0)){

                //LOOP: run thru sub menu items
                for(const link of this.subMenus){

                    // remove --menuSlide class from sub menu items
                    link.querySelector(`.${this.subMenuClass}`).classList.remove(this.menuSlideInClass);

                }

            // ERROR
            }else{

                // show error msg
                // console.log(`%c Error: Could not find the element using the selector: '.${this.iconExpandSubMenu}'!!!`, 'background:#f00; color:#fff');

            }

        }

        //MAIN MENU: delay menu collapse - speed based on visible submenu items
        const delayMenuCollapse = setTimeout((e) =>{

            // reset focus on logo after main menu is closed
            this.logo.parentNode.focus({preventScroll:true});  

            // remove --slideMenu class
            this.menu.classList.remove(this.menuSlideInClass);

            // update aria-hidden attribute
            this.menu.setAttribute("aria-hidden", true);

            // disable scroll on body
            this.body.classList.remove("--noscroll");

            // clear time out
            clearTimeout(delayMenuCollapse);

        // speed
        }, menuCollapseSpeed);

        // ICON: setup delay
        const delayIconChange = setTimeout((e) => {
            
            // grab burger menu child element
            const burger = (this.icon && this.icon.children) ? this.icon.children[0] : null;

            // revert to default
            if(burger && burger.classList.contains(this.iconExpandClass)) burger.classList.remove(this.iconExpandClass);
            
            //hide menu now - avoid resize glitching 
            this.menu.classList.add(this.opacityClass, this.invisibleClass);

            // clear time out
            clearTimeout(delayIconChange);

        //speed
        },((this.speed + iconChangeSpeedOffset) * 1000));

    }
    
    //SUB MENU: expand submenu link
    expandLink(e){

        // prevent default
        e.preventDefault();

        // get parent
        const parent = e.currentTarget.parentNode,
        subMenu = parent.querySelector(`.${this.subMenuClass}`);

        //make sure we have a subMenu    
        if(subMenu){

            // prevent scroll on main menu
            this.menu.classList.add(this.noScroll);

            // set menu back to top in case user has scrolled down -- otherwise we wont see the close bttn
            const showClose = setTimeout((e)=>{
                
                // scroll to top of main menu
                this.menu.scrollTo(0, 0);

                // clear time out
                clearTimeout(showClose);

            }, 369);

            // slide in sub menu - add --slideMenu and remove --transparent
            subMenu.classList.add(this.menuSlideInClass);
            subMenu.classList.remove(this.opacityClass);
        
            // set menu as current
            this.currentMenu(subMenu);

        // ERROR
        }else{

            // show error msg
            // console.log(`%c Error: Could not find the element using the selector: '.${this.subMenuClass}'!!!`, 'background:#f00; color:#fff');

        }

    }

    //SUB MENU: collapse submenu link
    collapseLink(e){

        // prevent default
        e.preventDefault();

        // get submenu which is the grandparent of our current element
        const subMenu = (this.menu) ? this.menu.querySelector(`.${this.current}`) : null;

        //if subMenu doesnt exist die silently
        if(!subMenu){

            // display error msg 
            // console.log(`%c Error: Could not find the element's parent node!!!`, 'background:#f00; color:#fff');

            // return
            return;

        }

        // set parent ul as current menu item by adding --current
        if(subMenu.parentNode && subMenu.parentNode.parentNode) this.currentMenu(subMenu.parentNode.parentNode);

        // slide in sub menu - add --slideMenu and remove --transparent
        subMenu.classList.remove(this.menuSlideInClass);
        
        //delay opcacity
        const delayOpacity = setTimeout((e) => {

            // remove noscroll from main menu
            this.menu.classList.remove(this.noScroll);

            // add opacity class
            subMenu.classList.add(this.opacityClass);

            // clear time out
            clearTimeout(delayOpacity);

        //speed
        }, (this.opacitySpeed * 1000));

    }

    // set class to define which menu is the current visible menu 
    // param [:menu] if left blank will just remove -current class
    currentMenu(menu = null){

        // check for error
        if(!this.menu){
            
            // display msg
            // console.log(`%c Error: Could not find the element using the selector: '.${this.menuClassName}'!!!`, 'background:#f00; color:#fff');

            //return
            return;
            
        }

        // remove tabindex
        this.accessibility(false);

        // remove any --current class within our menu
        const getCurrent = (this.menu) ? this.menu.querySelector(`.${this.current}`) : null;
        if(getCurrent) getCurrent.classList.remove(this.current);

        // - add --current class to current menu
        if(menu) menu.classList.add(this.current);

        // add tabindex for accessibility
        this.accessibility();

    }

    // setup accessibility for menu overlay - here you can add 
    // or remove tabindex - param [:add] is for removing if set to false
    accessibility(add = true){
        
        // check for error
        if(!this.menu){
            
            // display msg
            // console.log(`%c Error: Could not find the element using the selector: '.${this.menuClassName}'!!!`, 'background:#f00; color:#fff');

            //return
            return;
            
        }

        // if possible get current menu
        const menu = (this.menu) ? this.menu.querySelector(`.${this.current}`) : null,
        links = (menu) ? menu.children : null;

        // if local menu is not available just die silently
        if(!menu) return;

        // init tabindex start - pick a high number
        let count = 25000;

        // loop
        for(const item of links){

            // get link
            const link = item.querySelector("a"),

            // get prev element which should be the collapse button
            collapse = link.previousElementSibling,

            // get next element which should be the expand button,
            expand = link.nextElementSibling;

            // check for collapse
            if(collapse !== null){
                (add) ? collapse.setAttribute("tabindex", count++) : collapse.removeAttribute("tabindex"); 
            }
            
            // set link attribute
            (add && link) ? link.setAttribute("tabindex", count++) : link.removeAttribute("tabindex");

            // check for collapse
            if(expand !== null){
                (add) ? expand.setAttribute("tabindex", count++) : expand.removeAttribute("tabindex");
            }

        }    

        // set close button as end index for menu
        if(this.close) this.close.setAttribute("tabindex", (count++));

        // set focus to first menu item
        if(add) links[0].children[0].focus({preventScroll:true});

        // keep focus within current menu boundry
        if(add) this.tabbingBoundry(menu, links);

    }

    // keep tab focus within menu overlay
    tabbingBoundry(links){
        
        // check for error
        if(!this.menu){
            
            // display msg
            // console.log(`%c Error: Could not find the element using the selector: '.${this.menuClassName}'!!!`, 'background:#f00; color:#fff');

            //return
            return;
            
        }

        // make sure we have modal and tabbable array - or die silently
        if(this.menu && links && this.close){

            // setup last tab DOM items
            const lastTab = this.close;
            
            // add key event
            this.menu.addEventListener('keydown', (e) => {

                // stop propagation
                e.stopPropagation();
                e.stopImmediatePropagation();

                // get menu -- needs to be always checked - and get first tabbable item in our current menu
                const menu = (this.menu) ? this.menu.querySelector(`.${this.current}`) : null,
                firstTab = (menu && menu.children) ? menu.children[0].children[0] : null;

                // if firstTab is null just die silently
                if(firstTab === null) return;

                // get current focused item in DOM
                const currentFocus = document.activeElement;

                // check for tab key
                if(e.key.toLowerCase() === "tab"){
                    
                    // shift pressed also
                    if(e.shiftKey){

                        // check if we are on first tabindex
                        if(currentFocus === firstTab){

                            // prevent default
                            e.preventDefault();

                            // set focus on last item
                            lastTab.focus({preventScroll:true});

                        }

                    }

                    // check if we are on last tabindex
                    if(currentFocus === lastTab){

                        // prevent default
                        e.preventDefault();

                        // set focus on first tab item
                        firstTab.focus();

                    }

                }

                // check for enter key
                if(e.key.toLowerCase() === "enter"){
    
                    // init
                    const menuID = menu.getAttribute("id"),
                    closeButtonFocused = currentFocus.classList.contains(this.menuCloseClass);

                    //check if we are focused on the close button 
                    if(closeButtonFocused){

                        // if we are not at the root menu then collapse for better 
                        //accessibility - if we are on root menu close entire menu
                        (menuID === null) ? this.collapseLink(e) : this.collapseWholeMenu(e);

                    }
                
                }

            });

            // add key up for close button when menu is at root
            this.menu.addEventListener('keyup', (e) => {
                
                // stop propagation
                e.stopPropagation();
                e.stopImmediatePropagation();

                // check if escape was pressed
                if(e.key.toLowerCase() === "escape") this.collapseWholeMenu(e);

                // get menu, first tabbable element, current focused item and its if it contains the close class
                const menu = (this.menu) ? this.menu.querySelector(`.${this.current}`) : null,
                firstTab = (menu && menu.children) ? menu.children[0].children[0] : null,
                currentFocus = document.activeElement,
                closeFocused = currentFocus.classList.contains(this.menuCloseClass);

                // force to stay inside current menu - except if its the close button
                if(menu && !closeFocused && !menu.contains(currentFocus)) firstTab.focus();

            });

        }
        
    }

    // dynamically add anchor links to any submenu with (#)
    pound(){

        // check if menu exists
        if(this.menu){

            // get all href pound(#) links
            const poundLinks = this.menu.querySelectorAll("a[href*='#']");

            // make sure we have links
            if(poundLinks.length > 0){

                // loop: go thru all pound links 
                for(let i = 0; i < poundLinks.length; i++) {

                    // get link and link copy
                    const link = poundLinks[i],
                    parentHREF = (poundLinks[i].parentNode && poundLinks[i].parentNode.parentNode && poundLinks[i].parentNode.parentNode.parentNode) ? poundLinks[i].parentNode.parentNode.parentNode.querySelector("a").getAttribute("href") : null,


                    linkCopy = link.textContent.replace(/[\W_]+/g, "-").toLocaleLowerCase(),
                    url = `${parentHREF}#${linkCopy}`;
                
                    // make sure we have everything we need - 
                    if(link && linkCopy && parentHREF){

                        //update link dynamically
                        link.setAttribute("href", url);

                        // we are on the parent page of the link
                        if(parentHREF && (window.location.href.indexOf(parentHREF) !== -1)){
                            
                            // add event listener
                            link.addEventListener("click", (e) => {
                                
                                // prevent default
                                e.preventDefault();

                                // go to anchor (span) id
                                window.location.replace(e.target.getAttribute("href"));
                                
                                // close the menu
                                this.collapseWholeMenu(e);

                            });

                        }
                        
                    }

                }

            // no main nav links
            }else{

                // display msg
                // console.log(`%c Error: No links found in the main navigation.`, 'background:#f00; color:#fff');
                
                // return
                return;

            }



        // display error
        }else{

            // display msg
            // console.log(`%c Error: Could not find the element using the selector: '.${this.menuClassName}'!!!`, 'background:#f00; color:#fff');
            
            // return
            return;

        }

    }

}

// export
export default Menu;